/**
 * @generated SignedSource<<ff687281eb045fcdd1618911b1897b0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PrepareSignatureFileRendererQuery$variables = {
  id: string;
};
export type PrepareSignatureFileRendererQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"FileRenderer_node" | "PrepareSignatureFileRenderer_node" | "useNodeSecurity_node">;
  } | null;
};
export type PrepareSignatureFileRendererQuery = {
  response: PrepareSignatureFileRendererQuery$data;
  variables: PrepareSignatureFileRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roles",
  "storageKey": null
},
v8 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "MemberAvatar",
    "kind": "LinkedField",
    "name": "avatar",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v6/*: any*/)
    ],
    "storageKey": null
  },
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v12 = {
  "alias": "fileNameWithExtension",
  "args": [
    {
      "kind": "Literal",
      "name": "ensureExtension",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": "fileName(ensureExtension:true)"
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v6/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/)
  ],
  "type": "File",
  "abstractKey": null
},
v14 = [
  (v3/*: any*/)
],
v15 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v16 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "PendingFile",
  "abstractKey": null
},
v17 = [
  (v3/*: any*/),
  (v6/*: any*/)
],
v18 = [
  (v2/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v10/*: any*/)
    ],
    "type": "File",
    "abstractKey": null
  },
  (v15/*: any*/),
  (v16/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishState",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastModifiedAt",
  "storageKey": null
},
v23 = [
  (v6/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Thumbnail",
  "kind": "LinkedField",
  "name": "thumbnail",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v25 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canCreateSignatureEnvelope",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v29 = [
  (v4/*: any*/)
],
v30 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v10/*: any*/),
    (v6/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v9/*: any*/)
  ],
  "type": "File",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PrepareSignatureFileRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PrepareSignatureFileRenderer_node"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useNodeSecurity_node"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FileRenderer_node"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PrepareSignatureFileRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
          },
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SpaceMembershipConnection",
                    "kind": "LinkedField",
                    "name": "memberships",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SpaceMembershipEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SpaceMembership",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Member",
                                "kind": "LinkedField",
                                "name": "member",
                                "plural": false,
                                "selections": (v8/*: any*/),
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v13/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "data",
                        "storageKey": null
                      }
                    ],
                    "type": "Page",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormQuestion",
                        "kind": "LinkedField",
                        "name": "questions",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "text",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Form",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v17/*: any*/),
                    "type": "ExternalBridge",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v17/*: any*/),
                    "type": "InternalBridge",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "folderItemContent",
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              },
              (v19/*: any*/),
              (v4/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AuthorizationResult",
                "kind": "LinkedField",
                "name": "canRename",
                "plural": false,
                "selections": (v25/*: any*/),
                "storageKey": null
              },
              (v26/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Pin",
                    "kind": "LinkedField",
                    "name": "pins",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "context",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "HasPinsInterface",
                "abstractKey": "__isHasPinsInterface"
              }
            ],
            "type": "FolderItem",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Vault",
                "kind": "LinkedField",
                "name": "vault",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Member",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": true,
                    "selections": (v8/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthorizationResult",
                    "kind": "LinkedField",
                    "name": "canUpdate",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v13/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "vaultItemContent",
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "VaultUploadGroup",
                "kind": "LinkedField",
                "name": "uploadGroup",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Member",
                    "kind": "LinkedField",
                    "name": "publisher",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v27/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DateTime",
                    "kind": "LinkedField",
                    "name": "publishedAt",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "utcDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "utcTime",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/),
              (v26/*: any*/)
            ],
            "type": "VaultItem",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSignable",
                "storageKey": null
              },
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SignatureEnvelope",
                "kind": "LinkedField",
                "name": "signatureEnvelope",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SignaturesConnection",
                    "kind": "LinkedField",
                    "name": "signatures",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Signature",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Member",
                            "kind": "LinkedField",
                            "name": "member",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v27/*: any*/),
                              (v5/*: any*/),
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v28/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DateTime",
                            "kind": "LinkedField",
                            "name": "signedAt",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "datetime",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "currentFile",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v10/*: any*/),
                      (v6/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthorizationResult",
                    "kind": "LinkedField",
                    "name": "canSign",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthorizationResult",
                    "kind": "LinkedField",
                    "name": "canDelete",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthorizationResult",
                    "kind": "LinkedField",
                    "name": "canComplete",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "SignableInterface",
            "abstractKey": "__isSignableInterface"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AuthorizationResult",
                "kind": "LinkedField",
                "name": "canUpdateSecurity",
                "plural": false,
                "selections": (v25/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preventDownload",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasWatermark",
                "storageKey": null
              }
            ],
            "type": "HasNodeSecurityInterface",
            "abstractKey": "__isHasNodeSecurityInterface"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "draftVaultItemContent",
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              },
              {
                "alias": "draftContent_FileRenderer",
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v10/*: any*/),
                      (v6/*: any*/),
                      (v9/*: any*/)
                    ],
                    "type": "File",
                    "abstractKey": null
                  },
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "VaultDraftItem",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AuthorizationResult",
                "kind": "LinkedField",
                "name": "canPublish",
                "plural": false,
                "selections": (v25/*: any*/),
                "storageKey": null
              },
              (v19/*: any*/),
              (v21/*: any*/)
            ],
            "type": "FolderNodeInterface",
            "abstractKey": "__isFolderNodeInterface"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v19/*: any*/),
              (v4/*: any*/)
            ],
            "type": "Event",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "ownershipSpace",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "ownershipEvent",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "last",
                    "value": 1
                  }
                ],
                "concreteType": "FolderConnection",
                "kind": "LinkedField",
                "name": "ownershipFolders",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Folder",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": "ownershipFolders(last:1)"
              }
            ],
            "type": "HasOwnerPermissionsInterface",
            "abstractKey": "__isHasOwnerPermissionsInterface"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "announcementDate",
                "args": null,
                "kind": "ScalarField",
                "name": "publishedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Member",
                "kind": "LinkedField",
                "name": "announcer",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AnnouncementLink",
                "kind": "LinkedField",
                "name": "link",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "item",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v29/*: any*/),
                            "type": "Event",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v29/*: any*/),
                            "type": "Folder",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v29/*: any*/),
                            "type": "FolderItem",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v29/*: any*/),
                                    "type": "File",
                                    "abstractKey": null
                                  },
                                  (v15/*: any*/),
                                  (v16/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "AnnouncementAttachment",
                            "abstractKey": null
                          }
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Announcement",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v30/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "AnnouncementAttachment",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v30/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "MemberDetailsAttachment",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              (v21/*: any*/),
              (v22/*: any*/),
              (v24/*: any*/)
            ],
            "type": "Folder",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v27/*: any*/)
            ],
            "type": "Member",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v24/*: any*/)
            ],
            "type": "Vault",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Color",
                "kind": "LinkedField",
                "name": "color",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "light",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dark",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Space",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2aa0cc8875c8326e2a29a4b62574a79c",
    "id": null,
    "metadata": {},
    "name": "PrepareSignatureFileRendererQuery",
    "operationKind": "query",
    "text": "query PrepareSignatureFileRendererQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...PrepareSignatureFileRenderer_node\n    ...useNodeSecurity_node\n    ...FileRenderer_node\n    id\n  }\n}\n\nfragment DownloadButton_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ...useItemHandleFragment\n  ...useNodeSecurity_node\n  ... on FolderItem {\n    content {\n      __typename\n      ... on File {\n        id\n        url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultItem {\n    content {\n      __typename\n      ... on File {\n        url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n}\n\nfragment FileRenderer_node on Node {\n  __isNode: __typename\n  ...FolderNodePublishBar_folderNode\n  ...ItemOpenedTracker_item\n  ...useNodeSecurity_node\n  ...DownloadButton_node\n  ...SignatureStatusFileRenderer_node\n  __typename\n  id\n  ... on AnnouncementAttachment {\n    id\n    content {\n      __typename\n      ... on File {\n        id\n        name\n        fileName\n        fileNameWithExtension: fileName(ensureExtension: true)\n        mimeType\n        url\n        size\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on MemberDetailsAttachment {\n    content {\n      __typename\n      ... on File {\n        id\n        name\n        fileName\n        fileNameWithExtension: fileName(ensureExtension: true)\n        mimeType\n        url\n        size\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on FolderItem {\n    id\n    name\n    canRename {\n      value\n    }\n    content {\n      __typename\n      ... on File {\n        id\n        name\n        fileName\n        fileNameWithExtension: fileName(ensureExtension: true)\n        mimeType\n        url\n        size\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n    canCreateSignatureEnvelope {\n      value\n    }\n  }\n  ... on VaultItem {\n    id\n    content {\n      __typename\n      ... on File {\n        id\n        name\n        fileName\n        fileNameWithExtension: fileName(ensureExtension: true)\n        mimeType\n        url\n        size\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n    canCreateSignatureEnvelope {\n      value\n    }\n  }\n  ... on SignableInterface {\n    __isSignableInterface: __typename\n    signatureEnvelope {\n      id\n      status\n      signatures {\n        nodes {\n          id\n          member {\n            id\n          }\n          status\n        }\n      }\n      canSign {\n        value\n      }\n      currentFile {\n        __typename\n        id\n        name\n        fileName\n        fileNameWithExtension: fileName(ensureExtension: true)\n        mimeType\n        url\n        size\n      }\n    }\n  }\n  ... on VaultDraftItem {\n    id\n    draftContent_FileRenderer: content {\n      __typename\n      ... on File {\n        id\n        name\n        fileName\n        fileNameWithExtension: fileName(ensureExtension: true)\n        mimeType\n        url\n        size\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n}\n\nfragment FolderNodePublishBar_folderNode on FolderNodeInterface {\n  __isFolderNodeInterface: __typename\n  __typename\n  canPublish {\n    value\n  }\n  publishState\n  publishedAt\n  ... on Folder {\n    id\n  }\n  ... on FolderItem {\n    id\n    content {\n      __typename\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n    space {\n      id\n    }\n  }\n}\n\nfragment ItemOpenedTracker_item on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on FolderItem {\n    publishState\n  }\n  ... on Event {\n    publishState\n  }\n}\n\nfragment ManagersSteps_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on SignableInterface {\n    __isSignableInterface: __typename\n    signatureEnvelope {\n      id\n      status\n      signatures {\n        nodes {\n          id\n          member {\n            id\n            name\n            avatar {\n              url\n            }\n          }\n          status\n        }\n      }\n      canComplete {\n        value\n      }\n      canDelete {\n        value\n      }\n    }\n  }\n  ...SignersDetailsModal_node\n}\n\nfragment PrepareSignatureFileRenderer_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on FolderItem {\n    space {\n      memberships {\n        edges {\n          node {\n            member {\n              id\n              name\n              email\n              avatar {\n                name\n                url\n              }\n              ...UserHandle_member\n            }\n            id\n          }\n        }\n      }\n      id\n    }\n    content {\n      __typename\n      ... on File {\n        id\n        name\n        url\n        size\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultItem {\n    vault {\n      id\n      members {\n        id\n        name\n        email\n        avatar {\n          name\n          url\n        }\n        ...UserHandle_member\n      }\n      canUpdate {\n        value\n      }\n    }\n    content {\n      __typename\n      ... on File {\n        id\n        name\n        url\n        size\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on SignableInterface {\n    __isSignableInterface: __typename\n    isSignable\n    canCreateSignatureEnvelope {\n      value\n    }\n    signatureEnvelope {\n      id\n      status\n    }\n  }\n}\n\nfragment SignatureStatusFileRenderer_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on SignableInterface {\n    __isSignableInterface: __typename\n    isSignable\n    signatureEnvelope {\n      id\n      status\n      signatures {\n        nodes {\n          id\n          member {\n            id\n          }\n          status\n        }\n      }\n      currentFile {\n        __typename\n        id\n        name\n        fileName\n        fileNameWithExtension: fileName(ensureExtension: true)\n        mimeType\n        url\n        size\n      }\n      canSign {\n        value\n      }\n      canDelete {\n        value\n      }\n    }\n  }\n  ...ManagersSteps_node\n}\n\nfragment SignersDetailsModal_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on SignableInterface {\n    __isSignableInterface: __typename\n    signatureEnvelope {\n      id\n      signatures {\n        nodes {\n          id\n          status\n          signedAt {\n            datetime\n          }\n          member {\n            id\n            ...UserHandle_member\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment UserAvatar_member on Member {\n  name\n  email\n  avatar {\n    url\n  }\n}\n\nfragment UserHandle_member on Member {\n  id\n  name\n  email\n  ...UserAvatar_member\n  ...UserInfoPopover_member\n}\n\nfragment UserInfoPopover_member on Member {\n  id\n  name\n  email\n  roles\n  ...UserAvatar_member\n}\n\nfragment VaultItemAccessDetails_node on VaultItem {\n  id\n  uploadGroup {\n    publisher {\n      id\n      ...UserHandle_member\n    }\n    publishedAt {\n      utcDate\n      utcTime\n    }\n    id\n  }\n}\n\nfragment useItemHandleFragment on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on HasOwnerPermissionsInterface {\n    __isHasOwnerPermissionsInterface: __typename\n    ownershipSpace {\n      id\n    }\n    ownershipEvent {\n      id\n    }\n    ownershipFolders(last: 1) {\n      nodes {\n        id\n      }\n    }\n  }\n  ... on Announcement {\n    announcementDate: publishedAt\n    announcer {\n      id\n      name\n    }\n    link {\n      item {\n        __typename\n        ... on Node {\n          __isNode: __typename\n          id\n          ... on Event {\n            name\n          }\n          ... on Folder {\n            name\n          }\n          ... on FolderItem {\n            name\n          }\n          ... on AnnouncementAttachment {\n            content {\n              __typename\n              ... on File {\n                name\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n              ... on PendingFile {\n                id\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n  ... on AnnouncementAttachment {\n    thumbnail {\n      url\n    }\n    content {\n      __typename\n      ... on File {\n        id\n        name\n        mimeType\n        url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on MemberDetailsAttachment {\n    thumbnail {\n      url\n    }\n    content {\n      __typename\n      ... on File {\n        id\n        name\n        mimeType\n        url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Folder {\n    name\n    space {\n      id\n    }\n    publishedAt\n    lastModifiedAt\n    thumbnail {\n      url\n    }\n  }\n  ... on FolderItem {\n    name\n    label\n    publishedAt\n    lastModifiedAt\n    content {\n      __typename\n      ... on Page {\n        id\n        title\n        data\n      }\n      ... on File {\n        id\n        mimeType\n        url\n      }\n      ... on PendingFile {\n        id\n      }\n      ... on Form {\n        id\n        questions {\n          id\n          text\n        }\n      }\n      ... on ExternalBridge {\n        id\n        url\n      }\n      ... on InternalBridge {\n        id\n        url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    thumbnail {\n      url\n    }\n    ... on HasPinsInterface {\n      __isHasPinsInterface: __typename\n      pins {\n        context\n        id\n        label\n      }\n    }\n  }\n  ... on SignableInterface {\n    __isSignableInterface: __typename\n    signatureEnvelope {\n      id\n      status\n    }\n  }\n  ... on VaultItem {\n    ...VaultItemAccessDetails_node\n    name\n    uploadGroup {\n      publishedAt {\n        utcDate\n        utcTime\n      }\n      publisher {\n        name\n        id\n      }\n      id\n    }\n    content {\n      __typename\n      ... on File {\n        id\n        mimeType\n        url\n      }\n      ... on PendingFile {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Event {\n    name\n  }\n  ... on Member {\n    name\n    ...UserAvatar_member\n  }\n  ... on Vault {\n    name\n    thumbnail {\n      url\n    }\n  }\n  ... on Space {\n    name\n    color {\n      light\n      dark\n    }\n  }\n}\n\nfragment useNodeSecurity_node on Node {\n  __isNode: __typename\n  id\n  ... on HasNodeSecurityInterface {\n    __isHasNodeSecurityInterface: __typename\n    canUpdateSecurity {\n      value\n    }\n    preventDownload\n    hasWatermark\n  }\n  ... on FolderItem {\n    folderItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultItem {\n    vaultItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultDraftItem {\n    draftVaultItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "756a5d4020e6ad18ca967a47fe8c7c1c";

export default node;
